jQuery(document).ready(function ($) {
    $('.wp-block-wbdm-testimonials-carousel').each(function () {
        var $block = $(this);
        var $swiperContainer = $block.find('.testimonial-swiper');
        var $nextBtn = $block.find('.swiper-button-next.testimonials-next');
        var $prevBtn = $block.find('.swiper-button-prev.testimonials-prev');

        new Swiper($swiperContainer[0], {
            loop: false,
            spaceBetween: 24,
            slidesPerView: 1,
            grabCursor: true,
            navigation: {
                nextEl: $nextBtn[0],
                prevEl: $prevBtn[0],
            },
            observer: true,
            observeParents: true,
        });
    });
});
